module.exports = __webpack_public_path__ + "img/environmental.e8c7b06.svg";